/* eslint-disable prefer-const */

declare global {
  interface Window {
    // add you custom properties and methods
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    FB: any;
    fbAsyncInit: () => void;
  }
}

export default new Promise<void>(resolve => {
  window.fbAsyncInit = function() {
    window.FB.init({
      appId: "375584189780464",
      autoLogAppEvents: true,
      xfbml: true,
      version: "v6.0"
    });
    resolve();
  };
  (function(d, s, id) {
    // Load the SDK asynchronously
    let js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s) as HTMLScriptElement;
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    if (fjs.parentNode) fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");
});
